module.exports = __webpack_public_path__ + "img/chiva-cristal-main.40508e20.jpg";